import { Lesson } from "@jelly/lesson";
import config from "appConfig";
import { task as task01 } from "../../../task/course-05/lesson-01/task-01";
import { task as task02 } from "../../../task/course-05/lesson-01/task-02";
import theory from "./theory";

const lesson: Lesson = {
  id: "9a23dccc-d083-46cb-85a7-284342d2f748",
  publicId: "1",
  name: "What is the difference between room acoustics and building acoustics?",
  difficulty: 1,
  contentTypes: { audio: true, interactive: false, video: false },

  body: [
    {
      title: "",
      description:
        "A party is taking place at 01:00 AM in the red room (1) and the neighbour is trying to get some sleep in the blue room (2).",
      theory: theory,
      layout: {
        type: "table",
        options: {
          cols: 4,
          rows: 2,
          rowsSize: [5, 1],
          colsSize: [3, 2, 2, 3],
          colSpan: {
            "0:0": 4,
          },
          components: [
            [
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "image",
                    options: {
                      src: `${config.ASSETS_URL}/05/01/principle/slide-1.svg`,
                    },
                  },
                },
              },
            ],
            [
              null,
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "audioButton",
                    options: {
                      text: "red room",
                      url: `${config.ASSETS_URL}/05/01/principle/red-room.wav`,
                      icon: "cis-volume-high",
                      shape: "round",
                      theme: "primary",
                      size: "large",
                    },
                  },
                  styles: {
                    justifyContent: "flex-end",
                  },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "audioButton",
                    options: {
                      text: "blue room",
                      url: `${config.ASSETS_URL}/05/01/principle/blue-room.wav`,
                      icon: "cis-volume-high",
                      theme: "secondary",
                      shape: "round",
                      size: "large",
                    },
                  },
                  styles: {
                    justifyContent: "flex-start",
                  },
                },
              },
            ],
          ],
        },
      },
    },
    {
      title: "The field in acoustics that deals with sound insulation in architecture is:",
      description: "Select the correct answer.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        },
      },
    },
    {
      titleHtml:
        "The field in acoustics that deals with achieving optimal acoustic conditions in a room by<br>choosing appropriate size, shape and finishing materials is:",
      description: "Select the correct answer.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        },
      },
    },
  ],
};

export default lesson;
